export type GeoFailureReason =
	| 'permission_denied'
	| 'timeout'
	| 'sdk_load_failed'
	| 'token_failed'
	| 'verification_failed'
	| 'location_lost'

export const GEO_FAILURE_REASON = {
	PERMISSION_DENIED: 'permission_denied',
	TIMEOUT: 'timeout',
	SDK_LOAD_FAILED: 'sdk_load_failed',
	TOKEN_FAILED: 'token_failed',
	VERIFICATION_FAILED: 'verification_failed',
	LOCATION_LOST: 'location_lost',
} as const satisfies Record<string, GeoFailureReason>

export const FAILURE_CATEGORY_TO_REASON: Record<FailureCategory, GeoFailureReason> = {
	permission: 'permission_denied',
	integrity: 'verification_failed',
	error: 'location_lost',
}

export const REASON_TO_FAILURE_CATEGORY: Record<GeoFailureReason, FailureCategory> = {
	permission_denied: 'permission',
	verification_failed: 'integrity',
	timeout: 'error',
	sdk_load_failed: 'error',
	token_failed: 'error',
	location_lost: 'error',
}

export const GEO_FAILURE_REASONS: readonly GeoFailureReason[] = Object.values(GEO_FAILURE_REASON)

export function isValidGeoFailureReason(reason: unknown): reason is GeoFailureReason {
	return typeof reason === 'string' && (GEO_FAILURE_REASONS as readonly string[]).includes(reason)
}

/** LocateDeviceResult with optional inferred failure reason (enriched Failed variant). */
export type GeoLocationResult = LocateDeviceResult & { reason?: GeoFailureReason }
